const translation = {
  // Navbar
  nav_home: 'Startseite',
  nav_destinations: 'Reiseziele',
  nav_gallery: 'Galerie',
  nav_offers: 'IAEE 2026 CHILE',
  nav_testimonials: 'Bewertungen',
  nav_contact: 'Kontakt',
  nav_assistant: 'Assistent',

  // Hero
  hero_title: 'Entdecke Chile mit GaLi Travel',
  hero_subtitle: 'Dein Abenteuer beginnt hier',
  hero_cta: 'Reiseziele erkunden',

  // Destinations
  dest_title: 'Unvergessliche Reiseziele',
  dest_subtitle: 'Von der kargen Atacama-Wüste bis zu den Gletschern Patagoniens bietet Chile eine einzigartige Vielfalt an Landschaften und unvergesslichen Erlebnissen.',
  dest_see_more: 'Mehr sehen',

  // Offers
  offers_badge: 'EXKLUSIVE ANGEBOTE',
  offers_title: 'Mehr reisen,\nweniger ausgeben',
  offers_subtitle: 'Nutzen Sie unsere Sonderaktionen und entdecken Sie Chile zu den besten Preisen. Pakete, die einzigartige Erlebnisse ohne Budgetkompromisse ermöglichen.',
  offers_see_all: 'Alle Angebote ansehen',
  offers_valid_until: 'Gültig bis',
  offers_book_now: 'Jetzt buchen',

  // Testimonials
  test_title: 'Was unsere Reisenden sagen',

  // Contact
  contact_title: 'Planen Sie Ihre nächste Reise',
  contact_subtitle: 'Füllen Sie das Formular aus und wir melden uns bei Ihnen',
  contact_name: 'Vollständiger Name',
  contact_name_placeholder: 'Ihr Name',
  contact_email: 'E-Mail-Adresse',
  contact_phone: 'Telefon',
  contact_phone_placeholder: '+56 9 1234 5678',
  contact_destination: 'Reiseziel',
  contact_destination_select: 'Auswählen',
  contact_date: 'Reisedatum',
  contact_travelers: 'Anzahl der Reisenden',
  contact_person: 'Person',
  contact_persons: 'Personen',
  contact_message: 'Nachricht',
  contact_message_placeholder: 'Erzählen Sie uns von Ihrer Idealreise...',
  contact_chars: 'Zeichen',
  contact_submit: 'Anfrage senden',
  contact_submitting: 'Wird gesendet...',
  contact_success: 'Nachricht erfolgreich gesendet! Wir melden uns bald.',
  contact_error: 'Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  contact_phone_label: 'Telefon',
  contact_email_label: 'E-Mail',
  contact_whatsapp: 'WhatsApp',
  contact_whatsapp_available: 'Verfügbar 24/7',
  contact_hours: 'Öffnungszeiten',
  contact_hours_weekdays: 'Montag bis Freitag: 9:00 - 19:00',
  contact_hours_saturday: 'Samstag: 10:00 - 14:00',
  contact_quick_response: 'Schnelle Antwort',
  contact_quick_response_text: 'Wir antworten auf alle Anfragen innerhalb von 24 Stunden',

  // Footer
  footer_about: 'Über uns',
  footer_our_story: 'Unsere Geschichte',
  footer_team: 'Team',
  footer_values: 'Werte',
  footer_work_with_us: 'Arbeite mit uns',
  footer_popular_dest: 'Beliebte Reiseziele',
  footer_resources: 'Ressourcen',
  footer_travel_blog: 'Reiseblog',
  footer_destination_guides: 'Reiseführer',
  footer_travel_tips: 'Reisetipps',
  footer_faq: 'Häufige Fragen',
  footer_contact: 'Kontakt',
  footer_rights: '© 2024 GaLi Travel Chile. Alle Rechte vorbehalten.',
  footer_terms: 'AGB',
  footer_privacy: 'Datenschutz',
  footer_cert_sernatur: 'Sernatur-zertifiziert',
  footer_cert_safe: 'Sicherer Tourismus',
};

export default translation;
